// GENERATED by scripts/gen-firebase-config.js — do not commit (gitignored).
export const firebaseConfig = {
  "apiKey": "AIzaSyB8Fbu7CigE3yr8TxZ8tNimnraRttzZrBQ",
  "authDomain": "interlochen-callboard.firebaseapp.com",
  "projectId": "interlochen-callboard",
  "storageBucket": "interlochen-callboard.firebasestorage.app",
  "messagingSenderId": "549647818983",
  "appId": "1:549647818983:web:a3c94c4c770f425cd18242"
}

export const appCheckSiteKey = "6LfGT48tAAAAAKcsthLQ0NOAcYUzTbguAfGAsQSA"

export const useEmulators = false
